module.exports = __webpack_public_path__ + "web_static/img/blue_smile_animation.65a226f3.gif";